import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";
const LinksGridRow = ({
  title,
  date,
  status,
  original,
  shorten,
  clicks,
  index,
  selectedLinkSIndex,
  setSelectedLinkSIndex,
}) => {
  const [stat, setStat] = useState();
  useEffect(() => {
    if (status === "A") setStat("active");
    else if (status === "D") setStat("disable");
  });
  return (
    <tr
      key={index}
      onClick={() => {
        setSelectedLinkSIndex(shorten);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }}
      className={`cursor-pointer relative ${
        selectedLinkSIndex == shorten
          ? "bg-[#fbfbff] dark:bg-accent-600  border-primary-500 border-s-[3px]"
          : ""
      }`}
    >
      <td className="md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <p className="font-semibold text-primary-900 dark:text-accent-200 overflow-hidden whitespace-nowrap max-w-[300px] text-ellipsis">
          {title}
        </p>
      </td>
      <td className="md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <p className="font-medium overflow-hidden max-w-[160px] text-ellipsis whitespace-nowrap text-accent-300">
          {formatDate(date)}
        </p>
      </td>
      <td className="md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <p
          className={`text-xs font-medium w-fit py-[3px] px-10px relative rounded-full ps-20px capitalize before:w-[6px] before:h-[6px] before:block before:absolute before:left-10px before:rounded-full before:top-[calc(50%-3px)] ${
            status === "active"
              ? "bg-[#ecfdf3] dark:bg-[rgba(22,54,36,0.4)] text-[#039855] before:bg-[#039855]"
              : "bg-[#fff6f4] dark:bg-[rgba(255,112,84,0.2)] text-[#ff7054] before:bg-[#ff7054] "
          } `}
        >
          {status}
        </p>
      </td>
      <td className="font-medium overflow-hidden max-w-[160px] text-ellipsis whitespace-nowrap text-accent-300 md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <a href={original} className="original | ">
          {original}
        </a>
      </td>
      <td className="md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <a
          href={`/${shorten}`}
          className="font-medium text-primary-500"
          target="_blank"
        >
          {"snil.ink/" + shorten}
        </a>
      </td>
      <td className="md:py-[18px] py-12px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-accent-600">
        <p className="font-medium text-accent-300">{clicks}</p>
      </td>
    </tr>
  );
};

export default LinksGridRow;
